import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstacleIdleBehavior extends ObstacleBehavior {
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstacleIdle', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {}
  clone(): ObstacleIdleBehavior {
    return new ObstacleIdleBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
